// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import StorageSvg from '@rsuite/icon-font/lib/device/Storage';
var Storage = createSvgIcon({
  as: StorageSvg,
  ariaLabel: 'storage',
  category: 'device',
  displayName: 'Storage'
});
export default Storage;